module.exports = __webpack_public_path__ + "static/boopo-cff7058c2f547eac3e1e174cd2fac6f1.png";